export const fetchTextFile = async (filepath: string) => {
  return await fetch(filepath, {
    method: "get",
    headers: {
      "content-type": "application/text",
    },
  }).then((res) => res.text());
};
